import React from "react";
import history from '../../history';
import FichaPerfil from "../FichaPerfil";
import FichaEstadisticaAssist from "../NextAssist/FichaEstadisticaAssist"
import {
    AppstoreOutlined,
    CustomerServiceOutlined,
    DownOutlined,
    ExportOutlined,
    FileTextOutlined,
    FolderOutlined,
    SafetyOutlined,
    SettingOutlined,
    ShoppingOutlined,
    SolutionOutlined,
    UpOutlined,
    UserSwitchOutlined,
    SwapOutlined,
    DollarCircleOutlined,
    BookOutlined,
    FundOutlined,
    BarChartOutlined,
    RiseOutlined,
    ProjectOutlined,
    WechatOutlined
} from "@ant-design/icons";

import {
    cerrarSesion, obtenerUsuario,
    traducirPagina,

} from "../../librerias/funciones"

export const MenuApp = (props) => {
    const [activeMenu, setActiveMenu] = React.useState(0)
    const [Submenu, setSubmenu] = React.useState({
        MENU_SERTEC: false,
        MENU_PROVEEDOR: false,
        MENU_CONTROL: false,
        MENU_ASSIST: false
    });
    const [ABRIR_FICHA_PERFIL, setABRIR_FICHA_PERFIL] = React.useState(false)
    const [ABRIR_FICHA_ESTASISTICA_ASSIST, setABRIR_FICHA_ESTASISTICA_ASSIST] = React.useState(false)
    const { NOMBRE_USUARIO, SOCIOS, NOMBRE_ROL } = obtenerUsuario() !== undefined ? obtenerUsuario() : { NOMBRE_USUARIO: "", SOCIOS: [] }
    const [VALOR] = props.VARIABLES()

    return <>
        <div className="menuApp" style={{ width: `${VALOR}px` }}>
            <div className="logo_menu" onClick={() => {
                history.push("/home");
                setActiveMenu(0)
            }}>
                <img alt="logo Serca" src={`/imagenes/logo/${VALOR === props.ANCHO_MENU_GRANDE ? "serc_img_logo" : "LOGOSERCAPEQ"}.png`} style={VALOR === props.ANCHO_MENU_GRANDE ? { width: '190px' } : { width: '50px' }} />
            </div>

            <div className={`${VALOR === props.ANCHO_MENU_GRANDE ? "usuario_menu" : "usuario_menu_pq"}`}>
                {obtenerUsuario() !== undefined &&
                    <>
                        <div>{NOMBRE_USUARIO}</div>
                        <div>{SOCIOS.length === 1 ? SOCIOS[0].NOMBRE_SOCIO : NOMBRE_ROL}</div>
                    </>
                }
            </div>


            <ul className={`${VALOR === props.ANCHO_MENU_GRANDE ? "menu_opcion" : "menu_opcion_pq"}`}>
                <li>
                    <div key={1} onClick={() => {
                        history.push("/proveedores");
                        setActiveMenu(1)
                    }} className={activeMenu === 1 ? "activeMenuLateral" : ""}>
                        <UserSwitchOutlined></UserSwitchOutlined> {traducirPagina("Proveedores")}
                    </div>
                </li>
                <li>
                    <div key={2} onClick={() => {
                        history.push("/documentos");

                        setActiveMenu(2)
                    }} className={activeMenu === 2 ? "activeMenuLateral" : ""}>
                        <FolderOutlined></FolderOutlined> {traducirPagina("Documentos")}
                    </div>
                </li>
                <li>
                    <div onClick={() => {
                        history.push("/noticias");
                        setActiveMenu(3)
                    }} className={activeMenu === 3 ? "activeMenuLateral" : ""}>
                        <FileTextOutlined></FileTextOutlined> {traducirPagina("Noticias")}
                    </div>
                </li>
                <li>
                    <div onClick={() => {
                        history.push("/referencias");
                        setActiveMenu(4)
                    }} className={activeMenu === 4 ? "activeMenuLateral" : ""}>
                        <SwapOutlined></SwapOutlined> {traducirPagina("Referencias")}
                    </div>
                </li>
                <li>
                    <div onClick={() => {
                        history.push("/tarifas");
                        setActiveMenu(12)
                    }} className={activeMenu === 12 ? "activeMenuLateral" : ""}>
                        <DollarCircleOutlined></DollarCircleOutlined> {traducirPagina("Tarifas")}
                    </div>
                </li>
                <li>
                    <div onClick={() => {
                        history.push("/misconsumos");
                        setActiveMenu(21)
                    }} className={activeMenu === 21 ? "activeMenuLateral" : ""}>
                        <RiseOutlined></RiseOutlined> {traducirPagina("Consumos")}
                    </div>
                </li>
                <li>
                    <div onClick={() => { setActiveMenu(5); Submenu.MENU_SERTEC = Submenu.MENU_SERTEC ? false : true; setSubmenu({ ...Submenu }) }} className={activeMenu === 5 && "activeMenuLateral"}>
                        <ShoppingOutlined></ShoppingOutlined> Sertec
                        {Submenu.MENU_SERTEC ? <UpOutlined className="submenuLateral"></UpOutlined> : <DownOutlined className="submenuLateral"></DownOutlined>}
                    </div>
                </li>
                <li style={!Submenu.MENU_SERTEC ? { display: 'none' } : {}}>
                    <div onClick={() => {
                        history.push("/licenciassertec");
                        setActiveMenu(6)
                    }} className={`submenu_lateral ${activeMenu === 6 && "activeMenuLateral"}`}>
                        <SafetyOutlined></SafetyOutlined> {traducirPagina("Licencias")}
                    </div>
                </li>
                <li style={!Submenu.MENU_SERTEC ? { display: 'none' } : {}}>
                    <div onClick={() => {
                        history.push("/facturacionsertec");
                        setActiveMenu(7)
                    }} className={`submenu_lateral ${activeMenu === 7 && "activeMenuLateral"}`}>
                        <SolutionOutlined></SolutionOutlined> {traducirPagina("Facturacion")}
                    </div>
                </li>
                <li style={!Submenu.MENU_SERTEC ? { display: 'none' } : {}}>
                    <div onClick={() => {
                        history.push("/matriculassertec");
                        setActiveMenu(8)
                    }} className={`submenu_lateral ${activeMenu === 8 && "activeMenuLateral"}`}>
                        <BarChartOutlined></BarChartOutlined> {traducirPagina("Matriculas")}
                    </div>
                </li>

                {/* 
                <li style={!Submenu.MENU_SERTEC ? { display: 'none' } : {}}>
                    <div onClick={() => {
                        history.push("/marketing");
                        setActiveMenu(28)
                    }} className={`submenu_lateral ${activeMenu === 28 && "activeMenuLateral"}`}>
                        <ProjectOutlined></ProjectOutlined> {traducirPagina("label_marketing")}
                    </div>
                </li>

                <li style={!Submenu.MENU_SERTEC ? { display: 'none' } : {}}>
                    <div onClick={() => {
                        history.push("/mensajeria");
                        setActiveMenu(29)
                    }} className={`submenu_lateral ${activeMenu === 29 && "activeMenuLateral"}`}>

                        <WechatOutlined></WechatOutlined> {traducirPagina("Mensajeria")}
                    </div>
                </li>
*/}




                {/* 
                <li style={!Submenu.MENU_SERTEC ? { display: 'none' } : {}}>
                    <div onClick={() => {
                        history.push("/sustitucionAlmacenes");

                        setActiveMenu(17)
                    }} className={`submenu_lateral ${activeMenu === 17 && "activeMenuLateral"}`}>
                        <SafetyOutlined></SafetyOutlined> {"Sustitución de almacenes"}
                    </div>
                </li>
                <li style={!Submenu.MENU_SERTEC ? { display: 'none' } : {}}>
                    <div onClick={() => {
                        history.push("/filtrogrupomontaje");
                        setActiveMenu(18)
                    }} className={`submenu_lateral ${activeMenu === 18 && "activeMenuLateral"}`}>
                        <SafetyOutlined></SafetyOutlined> {"Filtro de grupos de montaje"}
                    </div>
                </li>

                <li style={!Submenu.MENU_SERTEC ? { display: 'none' } : {}}>
                    <div onClick={() => {
                        history.push("/filtroneumatico");
                        setActiveMenu(19)
                    }} className={`submenu_lateral ${activeMenu === 19 && "activeMenuLateral"}`}>
                        <SafetyOutlined></SafetyOutlined> {"Filtro de neumáticos"}
                    </div>
                </li>

                <li style={!Submenu.MENU_SERTEC ? { display: 'none' } : {}}>
                    <div onClick={() => {
                        history.push("/almacenesreguladores");
                        setActiveMenu(20)
                    }} className={`submenu_lateral ${activeMenu === 20 && "activeMenuLateral"}`}>
                        <SafetyOutlined></SafetyOutlined> {"Almacenes reguladores"}
                    </div>
                </li>
*/}
                <li>
                    <div onClick={() => { setActiveMenu(10); Submenu.MENU_ASSIST = Submenu.MENU_ASSIST ? false : true; setSubmenu({ ...Submenu }) }} className={activeMenu === 10 && "activeMenuLateral"}>
                        <CustomerServiceOutlined></CustomerServiceOutlined> Next assist
                        {Submenu.MENU_ASSIST ? <UpOutlined className="submenuLateral"></UpOutlined> : <DownOutlined className="submenuLateral"></DownOutlined>}

                    </div>
                </li>
                <li style={!Submenu.MENU_ASSIST ? { display: 'none' } : {}}>
                    <div onClick={() => { setABRIR_FICHA_ESTASISTICA_ASSIST(true); setActiveMenu(13) }} className={`submenu_lateral ${activeMenu === 13 && "activeMenuLateral"}`}>
                        <FundOutlined></FundOutlined> {traducirPagina("Estadisticas")}
                    </div>
                </li>
                <li style={!Submenu.MENU_ASSIST ? { display: 'none' } : {}}>
                    <div onClick={() => {
                        history.push("/licenciasnextassist");
                        setActiveMenu(14)
                    }} className={`submenu_lateral ${activeMenu === 14 && "activeMenuLateral"}`}>
                        <SafetyOutlined></SafetyOutlined> {traducirPagina("Licencias")}
                    </div>
                </li>

                <li style={!Submenu.MENU_ASSIST ? { display: 'none' } : {}}>
                    <div onClick={() => {
                        history.push("/facturacionnextassist");
                        setActiveMenu(15)
                    }} className={`submenu_lateral ${activeMenu === 15 && "activeMenuLateral"}`}>
                        <SolutionOutlined></SolutionOutlined> {traducirPagina("Facturacion")}
                    </div>
                </li>

                {/* 
                <li style={!Submenu.MENU_ASSIST ? { display: 'none' } : {}}>
                    <div onClick={() => {
                        history.push("/matriculasassist");
                        setActiveMenu(40)
                    }} className={`submenu_lateral ${activeMenu === 40 && "activeMenuLateral"}`}>
                        <BarChartOutlined></BarChartOutlined> {traducirPagina("Matriculas")}
                    </div>
                </li>

            */}







                <li>
                    <div onClick={() => { setActiveMenu(9) }} className={activeMenu === 9 && "activeMenuLateral"}>
                        <AppstoreOutlined></AppstoreOutlined> Next control
                    </div>
                </li>

                <li>
                    <div onClick={() => { setActiveMenu(16) }} className={activeMenu === 16 && "activeMenuLateral"}>
                        <BookOutlined></BookOutlined> Next data
                    </div>
                </li>
                {/* 
                <li>
                    <div onClick={() => {
                        history.push("/licenciasinfotechnic");
                        setActiveMenu(30);
                    }} className={activeMenu === 30 && "activeMenuLateral"}>
                        <BookOutlined></BookOutlined> Next infotechnic
                    </div>
                </li>
                */}

                <hr style={{ backgroundColor: '#fff' }}></hr>

                <li>
                    <div onClick={() => { setABRIR_FICHA_PERFIL(true); setActiveMenu(22) }} className={activeMenu === 22 && "activeMenuLateral"}>
                        <SettingOutlined></SettingOutlined> {traducirPagina("Mi_configuracion")}
                    </div>
                </li>
                <li>
                    <div onClick={() => { cerrarSesion() }}>
                        <ExportOutlined></ExportOutlined> {traducirPagina("Cerrar_sesion")}
                    </div>
                </li>
            </ul>
        </div>



        {ABRIR_FICHA_PERFIL ?
            <FichaPerfil
                title={traducirPagina("Mi_configuracion").toUpperCase()}
                ABRIR_FICHA={ABRIR_FICHA_PERFIL}
                CERRAR_FICHA={setABRIR_FICHA_PERFIL}
                ID_USUARIO={obtenerUsuario().ID}
                LLAMADA_DESDE={"BTN_PERFIL"}
            >
            </FichaPerfil>

            : null}

        {
            ABRIR_FICHA_ESTASISTICA_ASSIST ?
                <FichaEstadisticaAssist
                    title={`${traducirPagina("Estadisticas").toUpperCase()} NEXT ASSIST`}
                    ABRIR_FICHA={ABRIR_FICHA_ESTASISTICA_ASSIST}
                    CERRAR_FICHA={setABRIR_FICHA_ESTASISTICA_ASSIST}
                ></FichaEstadisticaAssist>
                :
                null
        }
    </>;
};